import { useContext } from "react";
import { Outlet } from "react-router-dom";

import {
  Alert,
  AlertTitle,
  AlertDescription,
  Fade,
  // AlertIcon,
} from '@chakra-ui/react';

import { PaymentContext } from 'business-layer/contexts/PaymentContext';

export const Layout = (): JSX.Element => {
  const gatewayConfig = useContext(PaymentContext) as any;
  const { mode = 'test' } = gatewayConfig;

  return (
    <div className="App">
      {mode === 'test' &&
        <Alert
          status="warning"
          variant={'top'}
          flexDir="row"
          // justifyContent={'center'}
          fontSize={'xs'}
          position={'absolute'}
          zIndex={1000}
          top={0}
          left={0}
          padding={0}
          alignItems={'baseline'}
        >
          <AlertTitle pl={0} width={'auto'}>Demo mode ON:</AlertTitle>
          <AlertDescription>Payments will not be collected.</AlertDescription>
        </Alert>
      }
      <Fade in={true}>
        <Outlet />
      </Fade>
    </div>
  );
}
